<template>
  <layout title="Classrooms">
    <div class="row">
      <div class="col-10">
        <h2>
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.index')"
          >
            Classrooms
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.edit', classroom.data.id)"
          >
            {{ classroom.data.name }}
          </inertia-link>
          / Students
        </h2>
      </div>
      <div class="col-md-2">
        <div
          class="float-right m-2 layout-select-btn"
          title="show as a list"
          @click="setDisplayMode('list')"
          :class="{ active: display == 'list' }"
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-list"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </div>

        <div
          class="float-right m-2 layout-select-btn"
          title="show as a grid"
          @click="setDisplayMode('grid')"
          :class="{ active: display == 'grid' }"
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-grid"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <button
                      :disabled="!addList.length"
                      class="btn btn-primary float-right"
                      @click="saveSelectedUsers"
                    >
                      Add
                      <span class="badge badge-light">
                        {{ addList.length }}
                      </span>
                    </button>
                    <h4>Unassigned Students</h4>
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div
                    class="mb-2"
                    v-for="student in unassigned_students.data"
                    :key="student.id"
                    :class="{
                      'col-md-6': display == 'grid',
                      'col-md-12': display == 'list',
                    }"
                  >
                    <div
                      class="card student-selector assigned-students"
                      :class="{ active: addList.includes(student.id) }"
                      @click="add(student.id)"
                    >
                      <div v-if="display == 'grid'" class="card-body">
                        <strong>{{ student.name }}</strong>
                        <br />
                        {{ student.email }}
                      </div>
                      <div v-else class="card-body p-1">
                        <strong>{{ student.name }}</strong>
                        &lt;{{ student.email }}&gt;
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 assigned-students-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <button
                      :disabled="!removeList.length"
                      class="btn btn-danger float-right"
                      @click="showUnassignConfirmationModal"
                    >
                      Remove
                      <span class="badge badge-light">
                        {{ removeList.length }}
                      </span>
                    </button>
                    <h4>Assigned Students</h4>
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div
                    class="mb-2"
                    v-for="student in assigned_students.data"
                    :key="student.id"
                    :class="{
                      'col-md-6': display == 'grid',
                      'col-md-12': display == 'list',
                    }"
                  >
                    <div
                      class="card student-selector unassigned-students"
                      :class="{ active: removeList.includes(student.id) }"
                      @click="remove(student.id)"
                    >
                      <div v-if="display == 'grid'" class="card-body">
                        <strong>{{ student.name }}</strong>
                        <br />
                        {{ student.email }}
                      </div>
                      <div v-else class="card-body p-1">
                        <strong>{{ student.name }}</strong>
                        &lt;{{ student.email }}&gt;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="unassignConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove students from the
              <strong>{{ classroom.data.name }}</strong>
              classroom
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to remove the selected
            {{ removeList.length }} student(s) from this classroom?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="removeSelectedUsers"
            >
              Yes, Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    classroom: Object,
    unassigned_students: Object,
    assigned_students: Object,
  },
  data() {
    return {
      display: "grid",
      addList: [],
      removeList: [],
    };
  },
  methods: {
    update() {
      this.$inertia.patch(
        route("classrooms.update", this.classroom.data.id),
        this.form
      );
    },
    add(id) {
      if (this.addList.includes(id)) {
        let index = this.addList.indexOf(id);
        this.addList.splice(index, 1);
      } else {
        this.addList.push(id);
      }
    },
    remove(id) {
      if (this.removeList.includes(id)) {
        let index = this.removeList.indexOf(id);
        this.removeList.splice(index, 1);
      } else {
        this.removeList.push(id);
      }
    },
    showUnassignConfirmationModal() {
      $("#unassignConfirmationModal").modal("show");
    },
    saveSelectedUsers() {
      this.$inertia
        .put(route("classrooms.students.add", this.classroom.data.id), {
          student_ids: this.addList,
        })
        .then(() => {
          this.addList = [];
        });
    },
    removeSelectedUsers() {
      this.$inertia
        .delete(route("classrooms.remove-students", this.classroom.data.id), {
          data: { student_ids: this.removeList },
          // student_ids: this.removeList
        })
        .then(() => {
          this.removeList = [];
        });
    },
    setDisplayMode(mode) {
      this.display = mode;
    },
  },
};
</script>
